import { useQuery } from 'react-query'
import esAPI from '@services/esAPI/esAPI'

export const useLastWatchTimeQuery = (sessionId) => {
  return useQuery(`last-watch-time-${sessionId}`, () =>
    esAPI('get', `/track/session/last-watch-time/${sessionId}`),
  )
}
